import { ContactPerson } from 'components/CommonStyles/ContactPerson';
import {
  dateFormat,
  formatDate,
} from 'helpers/StringNumberFunction/formatDate';
import { moneyFunction } from 'helpers/StringNumberFunction/moneyFunction';
import { amtStr, amtStr4Dec } from 'helpers/StringNumberFunction/numFormatter';
import React from 'react';

export const ELetterServicePurchase = ({
  docType,
  previewDetail,
  allpreviewDetail,
  paramVal,
  ItemIndex,
  approvalLog,
}) => {
  const formatMYNumber = (num: string = '') => {
    if (!num) return '';

    let cleaned = num.replace(/[^0-9+]/g, '').trim();

    if (!cleaned.startsWith('+')) {
      cleaned = '+' + cleaned;
    }

    if (cleaned.startsWith('+01') && cleaned.length > 5) {
      return (
        cleaned.slice(0, 1) + '6' + cleaned.slice(1, 4) + '-' + cleaned.slice(4)
      );
    }

    if (cleaned.startsWith('+60') && cleaned.length > 5) {
      return cleaned.slice(0, 5) + '-' + cleaned.slice(5);
    }

    return cleaned;
  };

  const companyDetails = JSON.parse(localStorage.getItem('companyDetails'));
  const formatTextWithLineBreaks = (text: string = '') => {
    if (!text) return '';
    return text.replace(/\n/g, '<br />');
  };

  let approverNameL1 = '';
  let approvalDateL1 = '';
  let roleNameL1 = '';
  let approverNameL2 = '';
  let approvalDateL2 = '';
  let roleNameL2 = '';
  let approverNameL3 = '';
  let approvalDateL3 = '';
  let roleNameL3 = '';
  let approverNameL4 = '';
  let approvalDateL4 = '';
  let roleNameL4 = '';
  let approverNameL5 = '';
  let approvalDateL5 = '';
  let roleNameL5 = '';

  if (approvalLog && approvalLog.length > 0) {
    const completedWorkflow = approvalLog.find(
      wf => wf.workFlowStatus === 'COMPLETED',
    );

    if (completedWorkflow?.workflowStep) {
      // Filter only approved steps and sort by stepNo
      const approvedSteps = completedWorkflow.workflowStep
        .filter(step => step.approvalStatus === 'APPROVED')
        .sort((a, b) => a.stepNo - b.stepNo);

      approvedSteps.forEach(step => {
        if (step.stepNo === 1) {
          approverNameL1 = step.name || '';
          approvalDateL1 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL1 = step.roleName || '';
        } else if (step.stepNo === 2) {
          approverNameL2 = step.name || '';
          approvalDateL2 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL2 = step.roleName || '';
        } else if (step.stepNo === 3) {
          approverNameL3 = step.name || '';
          approvalDateL3 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL3 = step.roleName || '';
        } else if (step.stepNo === 4) {
          approverNameL4 = step.name || '';
          approvalDateL4 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL4 = step.roleName || '';
        } else if (step.stepNo === 5) {
          approverNameL5 = step.name || '';
          approvalDateL5 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL5 = step.roleName || '';
        }
      });
    }
  }

  const creditorDetails = {
    '[SupplierName]': previewDetail?.Supplier?.CompanyName,
    '[SupplierAddress]': `${previewDetail?.Supplier?.Address?.address}<br />
          ${
            previewDetail?.Supplier?.Address?.country == 'Singapore'
              ? `${previewDetail?.Supplier?.Address?.country} ${previewDetail?.Supplier?.Address?.postCode}`
              : `${previewDetail?.Supplier?.Address?.postCode} ${previewDetail?.Supplier?.Address?.city}, 
            ${previewDetail?.Supplier?.Address?.state}, ${previewDetail?.Supplier?.Address?.country}`
          }
           <br />`,
    '[supplierContactPerson]':
      previewDetail?.supplier?.contactPerson?.length > 0
        ? previewDetail?.supplier?.contactPerson[0]?.name!
        : '',
    '[SupplierContactName]':
      previewDetail?.Supplier?.CreditorContact[0]?.Name! ?? '',
    '[supplierContactNo]': formatMYNumber(
      previewDetail?.supplier?.contactNo! ?? '',
    ),
    '[supplierPicContactNo]': formatMYNumber(
      previewDetail?.supplier?.contactPerson?.[0]?.contactNo! ?? '',
    ),
    '[SupplierContactEmail]':
      previewDetail?.Supplier?.CreditorContact[0]?.Email! ?? '',
    '[supplierEmail]':
      previewDetail?.supplier?.contactPerson?.length > 0
        ? previewDetail?.supplier?.contactPerson[0]?.email!
        : '',
    '[supplierRegNo]': previewDetail?.supplier?.registrationNo ?? '',
    // '[SupplierCompanyRegNo]': previewDetail?.Supplier?.CompanyRegNo! ?? '',
    // '[SupplierBankAccName]': previewDetail?.Supplier?.BankName! ?? '',
    // '[SupplierBankAccNo]': previewDetail?.Supplier?.BankAccountNo! ?? '',
    // '[SupplierTIN]': previewDetail?.Supplier?.einvoice_TIN! ?? '',
    '[SupplierSSTRegNo]': previewDetail?.Supplier?.SSTRegNo! ?? '',
    '[SupplierGSTRegNo]': previewDetail?.Supplier?.GSTRegNo! ?? '',
    // ============================
    // Common Document Header Info
    // ============================
    '[docNo]': previewDetail?.docNo! ?? '',
    '[docDate]': dateFormat(previewDetail?.docDate!) ?? '',
    '[contractTitle]': previewDetail?.contract?.title! ?? '',

    // ============================
    // Currency
    // ============================
    '[companyCurrency]':
      (companyDetails?.currency && companyDetails?.currency == 'Ringgit'
        ? 'Malaysian Ringgit'
        : companyDetails?.currency) ?? '',
    '[companyCurrencyCode]':
      previewDetail?.user?.companyCurrencyCode! ??
      companyDetails?.currencyCode ??
      '',
    '[currency]': allpreviewDetail?.currencyByDoc?.name ?? '',
    '[currencyRate]': (allpreviewDetail?.exchangeRate ?? 1.0).toFixed(8) ?? '',
    '[localDocAmt]': amtStr(
      allpreviewDetail?.totalAmt * (allpreviewDetail?.exchangeRate ?? 1.0),
    ),

    '[approverNameL1]': approverNameL1,
    '[approvalDateL1]': approvalDateL1,
    '[roleNameL1]': roleNameL1,
    '[approverNameL2]': approverNameL2,
    '[approvalDateL2]': approvalDateL2,
    '[roleNameL2]': roleNameL2,
    '[approverNameL3]': approverNameL3,
    '[approvalDateL3]': approvalDateL3,
    '[roleNameL3]': roleNameL3,
    '[approverNameL4]': approverNameL4,
    '[approvalDateL4]': approvalDateL4,
    '[roleNameL4]': roleNameL4,
    '[approverNameL5]': approverNameL5,
    '[approvalDateL5]': approvalDateL5,
    '[roleNameL5]': roleNameL5,
  };

  switch (docType) {
    case 'purchase-requisition':
      return Object.assign(paramVal, creditorDetails, {
        // ================================
        // Document Header and Footer Info
        // ================================
        '[requestedBy]': previewDetail?.requestedBy!,
        '[createdBy]': previewDetail?.createdBy!,
        '[supplierContactPerson]':
          previewDetail?.supplier?.contactPerson?.length > 0
            ? previewDetail?.supplier?.contactPerson[0]?.name!
            : '',
        '[contactPerson]': previewDetail?.contactPerson?.name!,
        '[contactNo]': formatMYNumber(previewDetail?.contactPerson?.contactNo!),
        '[deliveryLocation]': [
          previewDetail?.deliveryAddress?.address?.address!,
          previewDetail?.deliveryAddress?.address?.city!,
          previewDetail?.deliveryAddress?.address?.postCode!,
          previewDetail?.deliveryAddress?.address?.state!,
          previewDetail?.deliveryAddress?.address?.country!,
        ]
          // Concatenates if the data is Not Null
          .filter(Boolean)
          .join(', '),
        '[deliveryDate]': dateFormat(previewDetail?.expectedDate!),
        '[description]': formatTextWithLineBreaks(previewDetail?.instructions!),
        '[contractNo]': previewDetail?.contract?.contractNo!,
        '[siteName]': previewDetail?.deliveryAddress?.name ?? '',

        // =====================
        // Item Table Info
        // =====================
        items: previewDetail?.prItem
          ?.sort((a, b) => a?.sequence - b?.sequence)
          ?.map((el, i) => {
            return {
              '[index]': i + 1,
              '[itemDescription]': el?.costItem?.name!,
              // Tiny MCE seems to ignore \n, but respects <br />.
              // This ensures that poItem remark is the same as in db, refer to CX-3583
              '[itemRemark]': el?.remarks!.replace(/\n/g, '<br />') ?? '',
              '[uom]': el?.uom?.code,
              '[quantity]': amtStr4Dec(el?.requestedQty) ?? '',

              // =====================
              // Other Info
              // =====================
              '[Department]': el?.CostCentre?.Name,
              '[DeptCd]': el?.CostCentre?.Code,
              '[DeptCtNm]': el?.CostCentre?.FirstCostCentre?.Name,
              '[DeptCtCd]': el?.CostCentre?.FirstCostCentre?.Code,
              '[UnitCost]': amtStr4Dec(el?.UnitCost),
              '[TotalUnitCost]': amtStr(el?.TotalUnitCost),
            };
          }),
        '[SumTotalUnitCost]': amtStr(
          allpreviewDetail?.PRItem?.reduce(
            (a, b) => a + Number(b?.TotalUnitCost!),
            0,
          ),
        ),
      });
    case 'pr-on-behalf':
      return Object.assign(paramVal, creditorDetails, {
        // ================================
        // Document Header and Footer Info
        // ================================
        '[subcontractDetail]': previewDetail?.subcontract?.subcontractorDetail
          ?.name!,
        '[subcontractorName]':
          previewDetail?.subcontract?.subcontractorDetail?.name ?? '',
        '[subcontractTitle]': previewDetail?.subcontract?.title!,
        '[requestedBy]': previewDetail?.requestedBy!,
        '[createdBy]': previewDetail?.createdBy!,
        '[supplierContactPerson]':
          previewDetail?.supplier?.contactPerson?.length > 0
            ? previewDetail?.supplier?.contactPerson[0]?.name!
            : '',
        '[contactPerson]': previewDetail?.contactPerson?.name!,
        '[contactNo]': formatMYNumber(previewDetail?.contactPerson?.contactNo!),
        '[deliveryLocation]': [
          previewDetail?.deliveryAddress?.address?.address!,
          previewDetail?.deliveryAddress?.address?.postCode!,
          previewDetail?.deliveryAddress?.address?.city!,
          previewDetail?.deliveryAddress?.address?.state!,
          previewDetail?.deliveryAddress?.address?.country!,
        ]
          // Concatenates if the data is Not Null
          .filter(Boolean)
          .join(', '),
        '[deliveryDate]': dateFormat(previewDetail?.expectedDate!),
        '[description]': formatTextWithLineBreaks(previewDetail?.instructions!),
        '[contractNo]': previewDetail?.contract?.contractNo!,
        '[siteName]': previewDetail?.deliveryAddress?.name ?? '',

        // =====================
        // Item Table Info
        // =====================
        items: previewDetail?.prItem
          ?.sort((a, b) => a?.sequence - b?.sequence)
          ?.map((el, i) => {
            return {
              '[index]': i + 1,
              '[itemDescription]': el?.costItem?.name!,
              // Tiny MCE seems to ignore \n, but respects <br />.
              // This ensures that poItem remark is the same as in db, refer to CX-3583
              '[itemRemark]': el?.remarks!.replace(/\n/g, '<br />') ?? '',
              '[uom]': el?.uom?.code,
              '[quantity]': amtStr4Dec(el?.requestedQty) ?? '',

              // =====================
              // Other Info
              // =====================
              '[Department]': el?.CostCentre?.Name,
              '[DeptCd]': el?.CostCentre?.Code,
              '[DeptCtNm]': el?.CostCentre?.FirstCostCentre?.Name,
              '[DeptCtCd]': el?.CostCentre?.FirstCostCentre?.Code,
              '[UnitCost]': amtStr4Dec(el?.UnitCost),
              '[TotalUnitCost]': amtStr(el?.TotalUnitCost),
            };
          }),
        '[SumTotalUnitCost]': amtStr(
          allpreviewDetail?.PRItem?.reduce(
            (a, b) => a + Number(b?.TotalUnitCost!),
            0,
          ),
        ),
      });
    case 'rfq':
      return Object.assign(paramVal, creditorDetails, {
        // ================================
        // Document Header and Footer Info
        // ================================
        '[prNo]': previewDetail?.purchaseReq?.docNo!,
        '[supplierName]': previewDetail?.supplier[0]?.name!,
        '[supplierContactPerson]':
          previewDetail?.supplier?.contactPerson?.length > 0
            ? previewDetail?.supplier?.contactPerson[0]?.name!
            : '',
        '[description]': previewDetail?.description!,
        '[expectedDate]': formatDate(previewDetail?.expectedDate!),
        '[companyEmail]': previewDetail?.contract?.company?.Email! ?? '',
        '[contractTitle]': previewDetail?.contract?.title!,
        '[outgoingDocumentTitle]':
          previewDetail?.contract?.pdfDocumentTitle! ?? '',
        '[contractNo]': previewDetail?.contract?.contractNo!,
        '[contactPerson]': previewDetail?.purchaseReq?.contactPerson?.name!,
        '[contactNo]': formatMYNumber(
          previewDetail?.purchaseReq?.contactPerson?.contactNo!,
        ),
        '[deliveryLocation]': [
          previewDetail?.purchaseReq?.deliveryAddress?.address?.address!,
          previewDetail?.purchaseReq?.deliveryAddress?.address?.postCode!,
          previewDetail?.purchaseReq?.deliveryAddress?.address?.city!,
          previewDetail?.purchaseReq?.deliveryAddress?.address?.state!,
          previewDetail?.purchaseReq?.deliveryAddress?.address?.country!,
        ]
          // Concatenates if the data is Not Null
          .filter(Boolean)
          .join(', '),
        '[docDate]': formatDate(previewDetail?.docDate!),
        //Other Info
        '[specialInstruction]': formatTextWithLineBreaks(
          previewDetail?.instructions!,
        ),
        '[CreditTerm]': previewDetail?.CreditTerm!,
        '[quotationNo]':
          previewDetail?.supplier?.[0]?.latestSubmittedQuotation?.quotationNo ??
          '-',
        '[siteName]': previewDetail?.deliveryAddress?.name ?? '',

        // =====================
        // Item Table Info
        // =====================
        items: previewDetail?.rfqItem
          ?.sort((a, b) => a?.sequence - b?.sequence)
          ?.map((el, i) => {
            return {
              '[index]': i + 1,
              '[itemDescription]': el?.prItem?.costItem?.name!,
              // Tiny MCE seems to ignore \n, but respects <br />.
              // This ensures that poItem remark is the same as in db, refer to CX-3583
              '[itemRemark]':
                el?.prItem?.remarks!.replace(/\n/g, '<br />') ?? '',
              '[uom]': el?.uom?.code!,
              '[quantity]': amtStr4Dec(el?.quantity) ?? '',
              '[unitPrice]': amtStr4Dec(el?.unitPrice) ?? '',
              '[baseAmt]': el?.baseAmt,
              '[taxAmt]': el?.taxAmt,
              '[itemTaxAmt]': amtStr(el?.taxAmt!),
              '[totalAmt]': el?.totalAmt,
              // =====================
              // Other Info
              // =====================
              '[Department]': el?.Department,
              '[DeptCd]': el?.DeptCd,
              '[DeptCtNm]': el?.DeptCtNm,
              '[DeptCtCd]': el?.DeptCtCd,
              '[QuotationNo]': el?.quotationNo,
            };
          }),
        '[sumBaseAmt]': amtStr(
          allpreviewDetail?.POItemGroup?.reduce(
            (a, b) => a + Number(b?.baseAmt!),
            0,
          ),
        ),
        '[sumTaxAmt]': amtStr(
          allpreviewDetail?.POItemGroup?.reduce(
            (a, b) => a + Number(b?.taxAmt!),
            0,
          ),
        ),
        '[sumTotalAmt]': amtStr(
          allpreviewDetail?.POItemGroup?.reduce(
            (a, b) => a + Number(b?.totalAmt!),
            0,
          ),
        ),
      });
    case 'purchase-order':
    case 'direct-po': {
      const prNumbers = previewDetail?.poItem
        ?.map(item => item?.prItem?.purchaseReq?.docNo)
        .filter((docNo, index, self) => docNo && self.indexOf(docNo) === index) // Remove duplicates and nulls
        .join(', ');

      return Object.assign(paramVal, creditorDetails, {
        // ================================
        // Document Header and Footer Info
        // ================================
        '[prNo]': prNumbers || '-',
        '[supplierName]': previewDetail?.supplier?.name!,
        '[supplierAddress]':
          previewDetail?.supplier?.address?.country === 'Singapore'
            ? [
                previewDetail?.supplier?.address?.address,
                previewDetail?.supplier?.address?.postCode,
                previewDetail?.supplier?.address?.country,
              ]
                .filter(Boolean)
                .join(', ')
            : [
                previewDetail?.supplier?.address?.address!,
                previewDetail?.supplier?.address?.postCode!,
                previewDetail?.supplier?.address?.city!,
                previewDetail?.supplier?.address?.state!,
                previewDetail?.supplier?.address?.country!,
              ]
                .filter(Boolean)
                .join(', '),

        '[supplierContactPerson]':
          previewDetail?.supplier?.contactPerson?.length > 0
            ? previewDetail?.supplier?.contactPerson[0]?.name!
            : '',

        '[contactPerson]': previewDetail?.contactPerson?.name!,

        '[contactNo]': formatMYNumber(previewDetail?.contactPerson?.contactNo!),

        '[requestedBy]':
          previewDetail?.requestedBy ??
          previewDetail?.poItem?.[0]?.prItem?.purchaseReq?.requestedBy ??
          '-',
        '[contractNo]': previewDetail?.contract?.contractNo!,
        '[preparedBy]': previewDetail?.auditLog?.createdName!,
        '[companyEmail]': previewDetail?.contract?.company?.Email! ?? '',
        '[outgoingDocumentTitle]':
          previewDetail?.contract?.pdfDocumentTitle! ?? '',
        '[totalAmtInWords]': moneyFunction(previewDetail?.totalAmt ?? 0),
        // Concatenates Address Manually
        '[deliveryLocation]': [
          previewDetail?.deliveryAddress?.address?.address!,
          previewDetail?.deliveryAddress?.address?.postCode!,
          previewDetail?.deliveryAddress?.address?.city!,
          previewDetail?.deliveryAddress?.address?.state!,
          previewDetail?.deliveryAddress?.address?.country!,
        ]
          // Concatenates if the data is Not Null
          .filter(Boolean) //Skips the data if null
          .join(', '),
        '[deliveryDate]': dateFormat(previewDetail?.expectedDate!),
        '[specialInstruction]': formatTextWithLineBreaks(
          previewDetail?.instructions!,
        ),
        '[CreditTerm]': previewDetail?.CreditTerm!,
        '[paymentTerm]': previewDetail?.paymentTerm ?? '0',
        '[deliveryTerm]': previewDetail?.deliveryTerm ?? '',
        '[poRefNo]': previewDetail?.docRef!,
        '[termsConditions]': previewDetail?.termsConditions?.description ?? '',
        '[headerDescription]': previewDetail?.remarks!,
        '[totalAmt]': amtStr(previewDetail?.totalAmt),
        '[transactionStatus]': previewDetail?.purchaseStatus,
        '[siteName]': previewDetail?.deliveryAddress?.name ?? '',

        items: previewDetail?.poItem
          ?.sort((a, b) => (a?.index || 0) - (b?.index || 0)) // Sort by index, not sequence
          ?.map((el, i) => {
            const itemIndex = el?.index || i + 1;

            const costItemIsSubconTrade: boolean =
              el?.costItem?.costCategory?.costClass === 'SUBCONTRACT';

            return {
              '[index]': itemIndex.toString(), // Use global index instead of i + 1
              '[itemDescription]': costItemIsSubconTrade
                ? el?.costItem?.costCategory?.name
                : el?.costItem?.name,
              // Tiny MCE seems to ignore \n, but respects <br />.
              // This ensures that poItem remark is the same as in db, refer to CX-3583
              '[itemRemark]': el?.remarks!.replace(/\n/g, '<br />') ?? '',
              '[quantity]': amtStr4Dec(el?.orderedQty) ?? '',
              '[unitPrice]': amtStr4Dec(el?.unitPrice) ?? '',
              '[discountAmt]': amtStr(el?.discountAmt),
              '[taxCode]': el?.taxScheme?.name! ?? '',
              '[taxRate]': amtStr(
                el?.taxRate || el?.taxScheme?.latestTax?.taxRate || 0,
              ),
              '[taxAmt]': amtStr(el?.taxAmt),
              '[itemTaxAmt]': amtStr(el?.taxAmt!),
              // Base Amt dont need to add taxAmt and minus discount amt
              '[baseAmt]': amtStr((el?.orderedQty ?? 0) * (el?.unitPrice ?? 0)),
              '[itemTotalAmt]': amtStr(
                (el?.orderedQty ?? 0) * (el?.unitPrice ?? 0) +
                  (el?.taxAmt ?? 0) -
                  (el?.discountAmt ?? 0),
              ),
              // =====================
              // Other Info
              // =====================
              '[ItemPRNo]': el?.prItem?.prHeader?.docNo,
              '[uom]': el?.uom?.code,
              '[Department]': el?.CostCentre?.Name,
              '[DeptCd]': el?.CostCentre?.Code,
              '[DeptCtNm]': el?.CostCentre?.FirstCostCentre?.Name,
              '[DeptCtCd]': el?.CostCentre?.FirstCostCentre?.Code,
            };
          }),
        '[sumBaseAmt]': amtStr(
          allpreviewDetail?.poItem?.reduce(
            (a, b) => a + Number(b?.totalAmt! - b?.taxAmt!),
            0,
          ) ?? 0,
        ),
        '[sumTaxAmt]': amtStr(
          allpreviewDetail?.poItem?.reduce(
            (a, b) => a + Number(b?.taxAmt!),
            0,
          ) ?? 0,
        ),
        '[sumTotalAmt]': amtStr(
          allpreviewDetail?.poItem?.reduce(
            (a, b) =>
              a +
              ((b?.orderedQty ?? 0) * (b?.unitPrice ?? 0) +
                (b?.taxAmt ?? 0) -
                (b?.discountAmt ?? 0)),
            0,
          ) ?? 0,
        ),
      });
    }

    case 'po-on-behalf':
    case 'direct-po-on-behalf': {
      const prNumbers = previewDetail?.poItem
        ?.map(item => item?.prItem?.purchaseReq?.docNo)
        .filter((docNo, index, self) => docNo && self.indexOf(docNo) === index) // Remove duplicates and nulls
        .join(', ');

      return Object.assign(paramVal, creditorDetails, {
        // ================================
        // Document Header and Footer Info
        // ================================
        '[prNo]': prNumbers || '-',
        '[subcontractTitle]': previewDetail?.subcontract?.title!,
        '[supplierName]': previewDetail?.supplier?.name!,
        '[subcontractorName]':
          previewDetail?.subcontract?.subcontractorDetail?.name ?? '',
        // Concatenates Address Manually
        // If country is Singapore, only returns address (otherwise country and postcode will be duplicated)
        '[supplierAddress]':
          previewDetail?.supplier?.address?.country === 'Singapore'
            ? previewDetail?.supplier?.address?.address || ''
            : [
                previewDetail?.supplier?.address?.address!,
                previewDetail?.supplier?.address?.postCode!,
                previewDetail?.supplier?.address?.city!,
                previewDetail?.supplier?.address?.state!,
                previewDetail?.supplier?.address?.country!,
              ]
                // Concatenates if the data is Not Null
                .filter(Boolean) //Skips the data if null
                .join(', '),
        '[supplierContactPerson]':
          previewDetail?.supplier?.contactPerson?.length > 0
            ? previewDetail?.supplier?.contactPerson[0]?.name!
            : '',
        '[contactPerson]': previewDetail?.contactPerson?.name!,
        '[contactNo]': formatMYNumber(previewDetail?.contactPerson?.contactNo!),
        '[contractNo]': previewDetail?.contract?.contractNo!,
        '[requestedBy]':
          previewDetail?.requestedBy ??
          previewDetail?.poItem?.[0]?.prItem?.purchaseReq?.requestedBy ??
          '-',
        '[preparedBy]': previewDetail?.auditLog?.createdName!,
        '[companyEmail]': previewDetail?.contract?.company?.Email! ?? '',
        '[outgoingDocumentTitle]':
          previewDetail?.contract?.pdfDocumentTitle! ?? '',
        '[CreditTerm]': previewDetail?.CreditTerm!,
        '[paymentTerm]': previewDetail?.paymentTerm ?? '0',
        '[deliveryTerm]': previewDetail?.deliveryTerm ?? '',
        '[poRefNo]': previewDetail?.docRef!,
        '[totalAmtInWords]': moneyFunction(previewDetail?.totalAmt ?? 0),
        '[headerDescription]': previewDetail?.remarks!,
        // Concatenates Address Manually
        '[deliveryLocation]': [
          previewDetail?.deliveryAddress?.address?.address!,
          previewDetail?.deliveryAddress?.address?.postCode!,
          previewDetail?.deliveryAddress?.address?.city!,
          previewDetail?.deliveryAddress?.address?.state!,
          previewDetail?.deliveryAddress?.address?.country!,
        ]
          // Concatenates if the data is Not Null
          .filter(Boolean)
          .join(', '),
        '[deliveryDate]': dateFormat(previewDetail?.expectedDate!),
        '[specialInstruction]': formatTextWithLineBreaks(
          previewDetail?.instructions!,
        ),
        '[termsConditions]': previewDetail?.termsConditions?.description ?? '',
        '[transactionStatus]': previewDetail?.purchaseStatus,
        '[siteName]': previewDetail?.deliveryAddress?.name ?? '',

        // =====================
        // Item Table Info
        // =====================
        items: previewDetail?.poItem
          ?.sort((a, b) => (a?.index || 0) - (b?.index || 0)) // Sort by index, not sequence
          ?.map((el, i) => {
            const itemIndex = el?.index || i + 1;

            const costItemIsSubconTrade: boolean =
              el?.costItem?.costCategory?.costClass === 'SUBCONTRACT';

            return {
              '[index]': itemIndex.toString(),
              '[itemDescription]': costItemIsSubconTrade
                ? el?.costItem?.costCategory?.name
                : el?.costItem?.name,
              // Tiny MCE seems to ignore \n, but respects <br />.
              // This ensures that poItem remark is the same as in db, refer to CX-3583
              '[itemRemark]': el?.remarks!.replace(/\n/g, '<br />') ?? '',
              '[quantity]': amtStr4Dec(el?.orderedQty) ?? '',
              '[unitPrice]': amtStr4Dec(el?.unitPrice) ?? '',
              // Base Amt dont need to add taxAmt and minus discount amt
              '[baseAmt]': amtStr((el?.orderedQty ?? 0) * (el?.unitPrice ?? 0)),
              '[discountAmt]': amtStr(el?.discountAmt),
              '[taxCode]': el?.taxScheme?.code! ?? '',
              '[taxRate]': amtStr(
                el?.taxRate || el?.taxScheme?.latestTax?.taxRate || 0,
              ),
              '[taxAmt]': amtStr(el?.taxAmt),
              '[itemTaxAmt]': amtStr(el?.taxAmt!),
              '[totalAmt]': amtStr(el?.totalAmt),
              '[itemTotalAmt]': amtStr(
                (el?.orderedQty ?? 0) * (el?.unitPrice ?? 0) +
                  (el?.taxAmt ?? 0) -
                  (el?.discountAmt ?? 0),
              ),
              // =====================
              // Other Info
              // =====================
              '[ItemPRNo]': el?.PRItem?.PRHeader?.docNo,
              '[uom]': el?.uom?.code,
              '[Department]': el?.CostCentre?.Name,
              '[DeptCd]': el?.CostCentre?.Code,
              '[DeptCtNm]': el?.CostCentre?.FirstCostCentre?.Name,
              '[DeptCtCd]': el?.CostCentre?.FirstCostCentre?.Code,
            };
          }),
        '[sumBaseAmt]': amtStr(
          allpreviewDetail?.poItem?.reduce(
            (a, b) => a + Number(b?.totalAmt! - b?.taxAmt!),
            0,
          ) ?? 0,
        ),
        '[sumTaxAmt]': amtStr(
          allpreviewDetail?.poItem?.reduce(
            (a, b) => a + Number(b?.taxAmt!),
            0,
          ) ?? 0,
        ),
        '[sumTotalAmt]': amtStr(
          allpreviewDetail?.poItem?.reduce(
            (a, b) =>
              a +
              ((b?.orderedQty ?? 0) * (b?.unitPrice ?? 0) +
                (b?.taxAmt ?? 0) -
                (b?.discountAmt ?? 0)),
            0,
          ) ?? 0,
        ),
      });
    }

    case 'delivery-order':
      return Object.assign(paramVal, creditorDetails, {
        // ================================
        // Document Header and Footer Info
        // ================================
        '[DONo]': previewDetail?.doNo!,
        '[deliveryDate]': dateFormat(previewDetail?.transactionDate!),
        '[supplierName]': previewDetail?.supplier?.name!,
        '[supplierContactPerson]':
          previewDetail?.supplier?.contactPerson?.length > 0
            ? previewDetail?.supplier?.contactPerson[0]?.name!
            : '',
        // Concatenates Address Manually
        '[siteLocation]': [
          previewDetail?.site?.address?.address!,
          previewDetail?.site?.address?.postCode!,
          previewDetail?.site?.address?.city!,
          previewDetail?.site?.address?.state!,
          previewDetail?.site?.address?.country!,
        ]
          // Concatenates if the data is Not Null
          .filter(Boolean) //Skips the data if null
          .join(', '),

        // =====================
        // Item Table Info
        // =====================

        '[headerDescription]': previewDetail?.remarks!,

        items: previewDetail?.doItem
          ?.sort((a, b) => a?.sequence - b?.sequence)
          ?.map((el, i) => {
            return {
              '[index]': i + 1,
              '[itemDescription]': el?.poItem?.costItem?.name!,
              // Tiny MCE seems to ignore \n, but respects <br />.
              // This ensures that poItem remark is the same as in db, refer to CX-3583
              '[itemRemark]':
                el?.poItem?.remarks!.replace(/\n/g, '<br />') ?? '',
              '[uom]': el?.poItem?.uom?.code!,
              '[orderedQty]': amtStr4Dec(el?.poItem?.orderedQty) ?? '',
              '[outstandingQty]': amtStr4Dec(el?.poItem?.outstandingQty) ?? '',
              '[receivedQty]': amtStr4Dec(el?.deliveredQty) ?? '',
            };
          }),
        '[sumOrderedQty]': amtStr4Dec(
          allpreviewDetail?.doItem?.reduce(
            (a, b) => a + Number(b?.poItem?.orderedQty!),
            0,
          ) ?? 0,
        ),
        '[sumReceivedQty]': amtStr4Dec(
          allpreviewDetail?.doItem?.reduce(
            (a, b) => a + Number(b?.deliveredQty!),
            0,
          ) ?? 0,
        ),
        '[sumOutstandingQty]': amtStr4Dec(
          allpreviewDetail?.doItem?.reduce(
            (a, b) => a + Number(b?.poItem?.outstandingQty!),
            0,
          ) ?? 0,
        ),
      });

    case 'good-return-note':
      return Object.assign(paramVal, creditorDetails, {
        // ================================
        // Document Header and Footer Info
        // ================================
        '[docRef]': previewDetail?.docRef!,
        '[returnLocation]': previewDetail?.deliveryLocation?.Name!,
        '[returnDate]': dateFormat(previewDetail?.transactionDate!),
        '[createdBy]': previewDetail?.createdBy!,
        '[modifiedBy]': previewDetail?.modifiedBy!,
        '[supplierName]': previewDetail?.supplier?.name!,
        '[supplierContactPerson]':
          previewDetail?.supplier?.contactPerson?.length > 0
            ? previewDetail?.supplier?.contactPerson[0]?.name!
            : '',
        '[contractNo]': previewDetail?.contract?.contractNo!,
        // Concatenates Address Manually
        '[siteLocation]': [
          previewDetail?.site?.address?.address!,
          previewDetail?.site?.address?.postCode!,
          previewDetail?.site?.address?.city!,
          previewDetail?.site?.address?.state!,
          previewDetail?.site?.address?.country!,
        ]
          // Concatenates if the data is Not Null
          .filter(Boolean) //Skips the data if null
          .join(', '),
        '[headerDescription]': previewDetail?.description!,

        // =====================
        // Item Table Info
        // =====================
        items: previewDetail?.goodReturnNoteItem
          ?.sort((a, b) => a?.sequence - b?.sequence)
          ?.map((el, i) => {
            return {
              '[index]': i + 1,
              '[itemDescription]': el?.doItem?.poItem?.costItem?.name!,
              // Tiny MCE seems to ignore \n, but respects <br />.
              // This ensures that poItem remark is the same as in db, refer to CX-3583
              '[itemRemark]':
                el?.doItem?.poItem?.remarks!.replace(/\n/g, '<br />') ?? '',
              '[uom]': el?.doItem?.poItem?.costItem?.UOM?.code!,
              '[orderedQty]': amtStr4Dec(el?.doItem?.acceptedQty!) ?? '',
              '[returnedQty]': amtStr4Dec(el?.returnedQty!) ?? '',
            };
          }),

        '[sumReceivedQty]': amtStr4Dec(
          previewDetail?.goodReturnNoteItem?.reduce(
            (a, b) => a + Number(b?.doItem?.acceptedQty ?? 0),
            0,
          ) ?? 0,
        ),
        '[sumReturnedQty]': amtStr4Dec(
          previewDetail?.goodReturnNoteItem?.reduce(
            (a, b) => a + Number(b?.returnedQty ?? 0),
            0,
          ) ?? 0,
        ),
        '[sumReturnedAmt]': amtStr(
          allpreviewDetail?.GRTNHeaderItem?.reduce(
            (a, b) => a + Number(b?.returnedAmt!),
            0,
          ) ?? 0,
        ),
      });
  }
};
